export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'users.delete_staffposition',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:users:staffposition:export',
    },
  },
}